module.exports = __webpack_public_path__ + "img/message_2.aa0da7ac.png";